import { ContractsFilter, ContractViewModel } from '@ail/contracts-api'
import { useCallback, useEffect, useState } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { useLazyGetContractsQuery, useLazySearchContractsQuery } from '../../../redux/api/contractsApi'
import { useLazyGetOrderQuery } from '../../../redux/api/ordersApi'
import './OrderContractComponent.scss'
import { Loader } from '../../common/Loader/Loader'

export function OrderContract() {
  const [contract, setContract] = useState<ContractViewModel | null>()
  const [loading, setLoading] = useState(false)
  const params = useParams() as { orderId: string }

  const [getOrder] = useLazyGetOrderQuery()
  const [getContracts] = useLazyGetContractsQuery()
  const [searchContracts] = useLazySearchContractsQuery()

  const getOrderContract = useCallback(async () => {
    try {
      setLoading(true)
      setContract(undefined)
      const order = await getOrder(params.orderId, true).unwrap()
      const contractReference = order.data['OV001']
      let contract: ContractViewModel | undefined = undefined
      if (contractReference) {
        const contracts = await searchContracts({ searchTerm: contractReference, activeOnly: false }, true).unwrap()
        contract = contracts.at(0)
      }
      if (!contract) {
        const contracts = await getContracts(
          { contractFilter: ContractsFilter.ByRequest, requestId: params.orderId },
          true
        ).unwrap()
        contract = contracts.at(0)
      }
      setContract(contract ?? null)
    } catch {
      setContract(null)
    } finally {
      setLoading(false)
    }
  }, [getContracts, getOrder, searchContracts, params.orderId])

  useEffect(() => {
    getOrderContract()
  }, [getOrderContract])

  return (
    <Loader blocking={loading}>
      {!!contract && <Redirect to={`/generalContracts/details/${contract.id}`} />}
      {contract === null && (
        <div className="orderContractNotFound">
          Sorry, it seems the information you are looking for are not found or not yet available.
        </div>
      )}
    </Loader>
  )
}
